import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { remCalc } from "theme/utils";
import { Input as inputTheme } from "./input";

export const Select: ComponentStyleConfig = {
  baseStyle: {
    field: {
      // @ts-expect-error - The key exists in the input theme
      ...inputTheme.baseStyle?.field,
      appearance: "none",
      bg: "white",
      p: "smallest",
      pr: "big",
      lineHeight: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  sizes: {
    md: {
      field: {
        height: remCalc(44),
        // @ts-expect-error - The key exists in the input theme
        ...inputTheme.sizes?.md?.field,
      },
    },
  },
  variants: {
    outline: {
      ...inputTheme.variants?.outline,
    },
  },
  defaultProps: {
    size: "md",
  },
};
